<!-- If you change the layout or heights of any group/product related html -->
<!-- Go into the inventory-view-model-scroll-helper.ts/inventory-constants.ts and update the item heights -->

<!-- General Templates -->
<ng-template #itemDetails>
  <div
    data-cy="inventory-card-title-section"
    class="inventory-item-title"
    [class.offline]="!isOnline"
    *ngIf="!inventoryItem?.productMissingFlag"
  >
    <span
      (click)="handleProductDescriptionClick()"
      data-cy="inventory-card-title-text"
      *ngIf="inventoryItem?.nonUSFFlag"
    >
      <span class="non-usf-ind" data-cy="inventory-card-title-text-non-usf">
        {{ 'Non-USF: ' }}
      </span>
      {{
        inventoryItem?.productName | acronymTitleCase | truncateWithEllipsis: 55
      }}
    </span>
    <span
      (click)="handleProductDescriptionClick()"
      data-cy="inventory-card-title-text"
      *ngIf="!inventoryItem?.nonUSFFlag"
    >
      {{ inventoryItem?.productName | acronymTitleCase }}
    </span>
  </div>
  <div
    data-cy="inventory-card-title-section"
    class="inventory-item-title"
    [class.offline]="!isOnline"
    *ngIf="inventoryItem?.productMissingFlag"
  >
    <span
      (click)="handleProductDescriptionClick()"
      data-cy="inventory-card-title-text"
      class="missing-product"
    >
      {{ 'i18n.inventory.inventoryCardMissingProduct' | translate }}
    </span>
  </div>
  <div
    data-cy="inventory-count-card-num-pack-size-section"
    class="inventory-item-num-pack-size"
  >
    <p data-cy="inventory-count-card-product-number">
      #{{ inventoryItem?.productNumber }}
    </p>
    <img
      *ngIf="inventoryItem?.productPackSizeLabel"
      data-cy="inventory-count-card-separator-image"
      src="assets/images/separator.png"
    />
    <p data-cy="inventory-count-card-sales-pack-price">
      {{ inventoryItem?.productPackSizeLabel }}
    </p>
    <img
      *ngIf="inventoryItem?.productBrand"
      data-cy="inventory-count-card-separator-brand-image"
      src="assets/images/separator.png"
    />
    <p data-cy="inventory-count-card-brand-name">
      {{ inventoryItem?.productBrand | acronymTitleCase }}
    </p>
  </div>
</ng-template>

<ng-template #quantityCS>
  <div>
    <div class="missed-item-update-container">
      <p
        class="missed-item-update regular-font-weight"
        [class.visible]="
          !!inventoryItem?.missedItemUpdates &&
          inventoryItem.missedItemUpdates['caseOnHand']
        "
        data-cy="updated-case-on-hand-text"
      >
        {{ 'i18n.common.updated' | translate }}!
      </p>
      <app-decimal-quantity-input
        [productNumber]="inventoryItem?.productNumber"
        [quantity]="inventoryItem?.caseOnHand"
        [isEaches]="false"
        [isDisabled]="inventoryItem?.productCatchWeightFlag === true"
        [platform]="platform"
        [id]="'cs-' + inventoryId + '-' + index"
        [isProductCard]="false"
        (quantityUpdateEmitter)="handleCaseUpdate($event)"
        [customBorder]="
          inventoryItem?.productBadPricingCaseFlag
            ? borderRef.warning
            : inventoryItem?.productCatchWeightFlag
              ? borderRef.helpful
              : borderRef.plain
        "
        (click)="
          platform !== PlatformEnum.desktop
            ? handleCatchWeightHover($event)
            : undefined
        "
        (mouseover)="
          platform === PlatformEnum.desktop
            ? handleCatchWeightHover($event)
            : undefined
        "
        (mouseleave)="
          platform === PlatformEnum.desktop
            ? handleCatchWeightLeave()
            : undefined
        "
      ></app-decimal-quantity-input>
    </div>

    <div>
      <p
        *ngIf="
          !inventoryItem.productCatchWeightFlag &&
          inventoryItem?.casePrice !== -1
        "
        data-cy="inventory-count-card-quantity-case-text"
        class="price-text bold-font-weight"
      >
        {{ inventoryItem?.casePrice | currency }}&nbsp;
        {{ 'i18n.inventory.inventoryWorksheet.card.cs' | translate }}
      </p>
      <p
        *ngIf="
          !inventoryItem.productCatchWeightFlag &&
          inventoryItem?.casePrice === -1
        "
        data-cy="inventory-count-card-quantity-case-text"
        class="price-text bold-font-weight"
      >
        {{ 'i18n.inventory.inventoryWorksheet.card.na' | translate }}
      </p>
    </div>
  </div>
</ng-template>

<ng-template #quantityEA>
  <div>
    <div class="missed-item-update-container">
      <p
        class="missed-item-update regular-font-weight"
        [class.visible]="
          !!inventoryItem?.missedItemUpdates &&
          inventoryItem.missedItemUpdates['eachOnHand']
        "
        data-cy="updated-each-on-hand-text"
      >
        {{ 'i18n.common.updated' | translate }}!
      </p>
      <app-decimal-quantity-input
        [productNumber]="inventoryItem?.productNumber"
        [quantity]="inventoryItem?.eachOnHand"
        [isEaches]="true"
        [isDisabled]="false"
        [platform]="platform"
        [id]="'ea-' + inventoryId + '-' + index"
        [isProductCard]="false"
        (quantityUpdateEmitter)="handleEachUpdate($event)"
        [customBorder]="
          inventoryItem?.productBadPricingUnitFlag
            ? borderRef.warning
            : borderRef.plain
        "
      ></app-decimal-quantity-input>
    </div>
    <div>
      <p
        data-cy="inventory-count-card-quantity-each-text"
        *ngIf="
          inventoryItem?.unitPrice !== -1 &&
          inventoryItem?.unitPrice !== undefined
        "
        class="price-text bold-font-weight"
      >
        {{ inventoryItem?.unitPrice | currency }}&nbsp;/{{ inventoryItem.uom }}
      </p>
      <p
        data-cy="inventory-count-card-quantity-each-text"
        *ngIf="
          inventoryItem?.unitPrice === -1 ||
          inventoryItem?.unitPrice === undefined
        "
        class="price-text bold-font-weight"
      >
        {{ 'i18n.inventory.inventoryWorksheet.card.na' | translate }}
      </p>
    </div>
  </div>
</ng-template>

<!-- Templates for Main Card -->
<ng-template #desktopMain>
  <ion-row
    data-cy="inventory-count-card-content"
    class="ion-align-items-center inventory-card-content"
  >
    <!-- Line Number -->
    <ion-col
      data-cy="inventory-count-card-line-column"
      class="inventory-item-line"
      size="0.55"
      offset="0.2"
    >
      <span data-cy="inventory-count-card-line-text">
        {{ inventoryItem?.itemSequenceNumber ?? 1 }}
      </span>
    </ion-col>
    <!-- Product Details -->
    <ion-col
      data-cy="inventory-count-card-details-column"
      class="inventory-item-details"
      size="4.05"
      offset="0.25"
    >
      <ng-container [ngTemplateOutlet]="itemDetails"></ng-container>
    </ion-col>
    <!-- Cases -->
    <ion-col
      data-cy="inventory-count-card-case-column"
      class="inventory-item-quantity"
      size="2.125"
      offset="0.15"
    >
      <ng-container [ngTemplateOutlet]="quantityCS"></ng-container>
    </ion-col>
    <!-- Eaches -->
    <ion-col
      data-cy="inventory-count-card-each-column"
      class="inventory-item-quantity"
      size="2.125"
      offset="0.15"
    >
      <ng-container [ngTemplateOutlet]="quantityEA"></ng-container>
    </ion-col>
    <!-- Total -->
    <ion-col
      data-cy="inventory-count-card-total-column"
      class="inventory-item-total"
      size="1"
      offset="0.15"
    >
      <span data-cy="inventory-count-card-total-text">
        {{ inventoryItem?.total }}
      </span>
    </ion-col>
    <!-- Value -->
    <ion-col
      data-cy="inventory-count-card-value-column"
      class="inventory-item-value"
      size="1.25"
    >
      <span data-cy="inventory-count-card-value-text">
        {{ inventoryItem?.value | currency }}
      </span>
      <ion-icon
        name="information-circle"
        class="info-icon"
        [class.price-override]="inventoryItem?.overrideFlag"
        [class.catch-weight]="
          inventoryItem.productCatchWeightFlag &&
          !inventoryItem.productBadPricingUnitFlag
        "
        [class.bad-pricing]="
          inventoryItem.productBadPricingUnitFlag ||
          inventoryItem.productBadPricingCaseFlag
        "
        *ngIf="
          inventoryItem?.overrideFlag ||
          inventoryItem.productCatchWeightFlag ||
          inventoryItem.productBadPricingCaseFlag ||
          inventoryItem.productBadPricingUnitFlag
        "
        (click)="handleInfoIconClick()"
      ></ion-icon>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #tabletMain>
  <ion-row
    data-cy="inventory-count-card-content"
    class="ion-align-items-center inventory-card-content"
  >
    <!-- Line Number -->
    <ion-col
      data-cy="inventory-count-card-line-column"
      class="inventory-item-line"
      size="0.5"
    >
      <span data-cy="inventory-count-card-line-text">
        {{ inventoryItem?.itemSequenceNumber ?? 1 }}
      </span>
    </ion-col>
    <!-- Product Info -->
    <ion-col data-cy="inventory-count-card-product-column" size="11.5">
      <!-- Product Details -->
      <ion-row data-cy="inventory-count-card-product-info-row">
        <ion-col
          data-cy="inventory-count-card-details-column"
          class="inventory-item-details"
          size="11.5"
        >
          <ng-container [ngTemplateOutlet]="itemDetails"></ng-container>
        </ion-col>
        <ion-col size="0.5">
          <ion-icon
            name="information-circle"
            class="info-icon"
            [class.price-override]="inventoryItem?.overrideFlag"
            [class.catch-weight]="
              inventoryItem.productCatchWeightFlag &&
              !inventoryItem.productBadPricingUnitFlag
            "
            [class.bad-pricing]="
              inventoryItem.productBadPricingUnitFlag ||
              inventoryItem.productBadPricingCaseFlag
            "
            *ngIf="
              inventoryItem?.overrideFlag ||
              inventoryItem.productCatchWeightFlag ||
              inventoryItem.productBadPricingCaseFlag ||
              inventoryItem.productBadPricingUnitFlag
            "
            (click)="handleInfoIconClick()"
          ></ion-icon>
        </ion-col>
      </ion-row>
      <!-- Cases, Eaches, Total -->
      <ion-row
        data-cy="inventory-count-card-product-quantity-row"
        class="inventory-card-quantity-row"
      >
        <ion-col
          data-cy="inventory-count-card-case-column"
          class="inventory-item-quantity"
          size="4.15"
        >
          <ng-container [ngTemplateOutlet]="quantityCS"></ng-container>
        </ion-col>
        <ion-col
          data-cy="inventory-count-card-each-column"
          class="inventory-item-quantity"
          size="4.15"
          offset="0.5"
        >
          <ng-container [ngTemplateOutlet]="quantityEA"></ng-container>
        </ion-col>
        <ion-col
          data-cy="inventory-count-card-total-column"
          class="inventory-item-total"
          size="2"
          offset="1.2"
        >
          <span data-cy="inventory-count-card-total-text">
            {{
              'i18n.inventory.inventoryWorksheet.card.total' | translate
            }}&nbsp;
            {{ inventoryItem?.total }}
          </span>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #mobileMain>
  <ion-row data-cy="inventory-count-card-line-details-row">
    <ion-col
      data-cy="inventory-count-card-line-column"
      class="inventory-item-line"
      size="1"
    >
      <span data-cy="inventory-count-card-line-text">
        {{ inventoryItem?.itemSequenceNumber ?? 1 }}
      </span>
    </ion-col>
    <ion-col
      data-cy="inventory-count-card-details-column"
      class="inventory-item-details"
      size="10.5"
    >
      <ng-container [ngTemplateOutlet]="itemDetails"></ng-container>
    </ion-col>
    <ion-col size="0.5">
      <ion-icon
        name="information-circle"
        class="info-icon"
        [class.price-override]="inventoryItem?.overrideFlag"
        [class.catch-weight]="
          inventoryItem.productCatchWeightFlag &&
          !inventoryItem.productBadPricingUnitFlag
        "
        [class.bad-pricing]="
          inventoryItem.productBadPricingUnitFlag ||
          inventoryItem.productBadPricingCaseFlag
        "
        *ngIf="
          inventoryItem?.overrideFlag ||
          inventoryItem.productCatchWeightFlag ||
          inventoryItem.productBadPricingCaseFlag ||
          inventoryItem.productBadPricingUnitFlag
        "
        (click)="handleInfoIconClick()"
      ></ion-icon>
    </ion-col>
  </ion-row>

  <ion-row data-cy="inventory-count-card-quantities-row">
    <ion-col
      data-cy="inventory-count-card-case-column"
      class="inventory-item-quantity"
      size="5.75"
    >
      <ng-container [ngTemplateOutlet]="quantityCS"></ng-container>
    </ion-col>
    <ion-col
      data-cy="inventory-count-card-each-column"
      class="inventory-item-quantity"
      size="5.75"
      offset="0.5"
    >
      <ng-container [ngTemplateOutlet]="quantityEA"></ng-container>
    </ion-col>
  </ion-row>
</ng-template>
<!-- End Templates -->

<div
  class="inventory-card-container"
  [ngClass]="
    platform !== PlatformEnum.desktop
      ? platform === PlatformEnum.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <ion-card class="inventory-card-main">
    <ng-container
      *ngIf="platform === PlatformEnum.desktop"
      [ngTemplateOutlet]="desktopMain"
    ></ng-container>
    <ng-container
      *ngIf="platform === PlatformEnum.tablet"
      [ngTemplateOutlet]="tabletMain"
    >
    </ng-container>
    <ng-container
      *ngIf="platform === PlatformEnum.mobile"
      [ngTemplateOutlet]="mobileMain"
    ></ng-container>
  </ion-card>
  <div *ngIf="platform !== PlatformEnum.desktop" class="inventory-card-sub">
    <ion-label
      *ngIf="platform === PlatformEnum.mobile"
      data-cy="inventory-count-card-total-mobile"
      class="inventory-item-total"
    >
      <p>
        {{ 'i18n.inventory.inventoryWorksheet.card.total' | translate }}
        {{ inventoryItem.total }}
      </p>
    </ion-label>
    <ion-label
      data-cy="inventory-count-card-value-touch"
      class="inventory-item-value"
      slot="end"
    >
      <p>
        {{ 'i18n.inventory.inventoryWorksheet.card.value' | translate }}
        {{ inventoryItem.value | currency }}
      </p>
    </ion-label>
  </div>
</div>
